export type {
  ExamBoardConfig,
  ExamBoardId,
  ExamBoardStatus,
  ExamModule,
  ExamSitting,
  ModuleClassification,
  ReplacedTest,
  ScoreConversion,
  ScoringScale,
  University,
  UniversityCourse,
  UniversityRequirement,
} from "./types";

export { EXAM_BOARDS, DEFAULT_BOARD_ID } from "./boards";
export {
  EARLY_BIRD_DEADLINE,
  EARLY_BIRD_DEADLINE_ISO,
  SALE_DEADLINE,
  SALE_DEADLINE_ISO,
} from "./pricing";
export { resolveBoard, resolveBoardId, resolveSitting } from "./domain";
export { bandFromScorePct, nationalPercentileForBand } from "./scoring";

import { EXAM_BOARDS } from "./boards";
import type { ExamBoardConfig, ExamBoardId } from "./types";

/** All boards as an array (e.g. for selectors / sitemaps). */
export const ALL_BOARDS: ExamBoardConfig[] = Object.values(EXAM_BOARDS);

/** Boards currently served on a live domain. */
export const ACTIVE_BOARDS: ExamBoardConfig[] = ALL_BOARDS.filter(
  (b) => b.status === "active",
);

/** Look up a board by its id (matches the persisted `examBoard` string). */
export function getBoard(id: ExamBoardId): ExamBoardConfig {
  return EXAM_BOARDS[id];
}
